// src/components/Contact.tsx
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Contact = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="mx-auto max-w-md text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif text-coffee-800 mb-4">Visit Us</h2>
          <div className="w-16 h-1 bg-coffee-400 mx-auto mb-6"></div>
          <p className="text-coffee-600">
            Bring your laptop or a good book and enjoy our cozy atmosphere
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <img 
              src="https://images.unsplash.com/photo-1554118811-1e0d58224f24?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2047&q=80" 
              alt="Moca coffee shop interior" 
              className="rounded-lg shadow-lg w-full h-auto object-cover"
            />
          </div>
          
          <div>
            <h3 className="text-2xl font-serif text-coffee-800 mb-6">Our Café</h3>
            <p className="text-coffee-700 mb-8">
              We've created a warm, inviting space where you can enjoy our freshly roasted coffee,
              catch up with friends, or get some work done. Our baristas are coffee experts who
              take pride in crafting the perfect drink for you.
            </p>
            
            <div className="space-y-6">
              <ContactItem 
                icon={<MapPin className="h-5 w-5 text-coffee-500" />}
                title="Address"
                details={<>123 Coffee Street<br />San Francisco, CA 94110</>}
              />
              
              <ContactItem 
                icon={<Phone className="h-5 w-5 text-coffee-500" />}
                title="Phone"
                details="(555) 123-4567"
              />
              
              <ContactItem 
                icon={<Mail className="h-5 w-5 text-coffee-500" />}
                title="Email"
                details="hello@mocacoffee.com"
              />
              
              <ContactItem 
                icon={<Clock className="h-5 w-5 text-coffee-500" />}
                title="Hours"
                details={<>
                  Monday - Friday: 7AM - 7PM<br />
                  Saturday - Sunday: 8AM - 6PM
                </>}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const ContactItem = ({ 
  icon, 
  title, 
  details 
}: { 
  icon: React.ReactNode; 
  title: string; 
  details: React.ReactNode;
}) => {
  return (
    <div className="flex items-start">
      <div className="bg-coffee-100 p-3 rounded-lg mr-4">
        {icon}
      </div>
      <div>
        <h4 className="font-medium text-coffee-800 mb-1">{title}</h4>
        <div className="text-coffee-600">{details}</div>
      </div>
    </div>
  );
};

export default Contact;